import { SubSurveysManagerReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class SubSurveysManagerDialogViewModel
{
    opened: boolean = false;

    rm: SubSurveysManagerReadModel | null = null;
    masterSurveyId: number | null = null;
    masterSurveyName: string | null = null;

    show(masterSurveyId: number, masterSurveyName: string)
    {
        this.masterSurveyId = masterSurveyId;
        this.masterSurveyName = masterSurveyName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.rm = null;
    }

    setData(rm: SubSurveysManagerReadModel)
    {
        this.rm = rm;
    }

    excludeSubSurvey(surveyId: number)
    {
        const s = this.rm!.Entries.find(a => a.Id === surveyId);

        if (s)
        {
            s.IsIncluded = false;
        }
    }

    includeSubSurvey(surveyId: number, voteStrength: number)
    {
        const s = this.rm!.Entries.find(a => a.Id === surveyId);

        if (s)
        {
            s.VoteStrength = voteStrength;
            s.IsIncluded = true;
        }
    }

    changeSubSurveyVoteStrength(surveyId: number, voteStrength: number)
    {
        const s = this.rm!.Entries.find(a => a.Id === surveyId);

        if (s)
        {
            s.VoteStrength = voteStrength;
        }
    }
}